import { Component, Input, Output, OnInit, EventEmitter, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { CountryModel } from '../core/services';
import { DropdownValue } from '../shared/dropdown.model';
import { DashboardFilterModel } from './dashboard-filter-model';
import { FilterItemsService } from '../shared/filter-items.service';
import { StorageService, DateHelperService } from "../core/services/index";
import { consts } from "../shared/consts";
import { MediationFilters } from "../mediation/mediation.filters";
import { ProviderTreeSelectionModalComponent } from "../shared/providers-tree-selection-modal.component";
import { BrowserService } from "../core/services/browser.service";

@Component({
    selector: 'dashboard-filter',
    templateUrl: 'dashboard-filter.component.html',
    encapsulation: ViewEncapsulation.None
})
export class DashboardFilterComponent implements OnInit {
    public periodValues: Array<DropdownValue> = [];
    public countryValues: Array<DropdownValue> = [];
    public periodPrefix: string = "Period";
    public countryPrefix: string = "Country";
    public defaultPeriodSelection: DropdownValue;
    public defaultCountrySelection: DropdownValue;
    private filters: DashboardFilterModel;
    public showCustomPeriod: boolean = false;
    private readonly customValue: number = 9;
    public startDate: Date;
    public endDate: Date;
    public dateError: string;
    public fromMaxDate: Date = new Date();
    public fromMinDate: Date = new Date();
    public toMaxDate: Date = new Date();
    public toMinDate: Date = new Date();

    @Input() show: boolean = true;
    @Input() showProviders: boolean = true;
    @Input() panelId: string;
    @Output() filterChanged: EventEmitter<DashboardFilterModel> = new EventEmitter<DashboardFilterModel>();
    @ViewChild("providerTreeSelectionModal") providerTreeSelectionModalComponent: ProviderTreeSelectionModalComponent

    constructor(
        private storageService: StorageService,
        private filterItemsService: FilterItemsService,
        private el: ElementRef,
        private dateHelperService: DateHelperService,
        private browserSerive: BrowserService ) {
        }

    ngOnInit() {
        this.panelId = "";
        var today = new Date();
        var first = today.getDate() - 180;
        this.fromMinDate = this.dateHelperService.utcDateOnly(new Date(today.setDate(first)));
        this.toMinDate = this.fromMinDate;

        if (this.show) {
            this.periodValues = this.filterItemsService.getPeriods();
            this.defaultPeriodSelection = this.filterItemsService.getDefaultPeriodSelection();

            this.countryValues = this.filterItemsService.getCountries(true);
            this.defaultCountrySelection = this.filterItemsService.getDefaultCountrySelection(true);

            let providerIds = new Array<number>();
            providerIds = this.filterItemsService.getNonConfigurableProvidersIds();
            
            let publisherIds = new Array<number>();
            let publisherFromStorage = this.storageService.get(consts.PublisherIdsFilterStorageKey);
            if (publisherFromStorage) publisherIds = <Array<number>>publisherFromStorage;
            else {
                let mediationFilter = <MediationFilters>this.storageService.get(consts.MediationFilterStorageKey);
                if (mediationFilter != null && mediationFilter.publisherId != null) publisherIds.push(mediationFilter.publisherId);
                else publisherIds = this.filterItemsService.getPublishersIds();
            }
            this.filters = new DashboardFilterModel(
                this.filterItemsService.getMinValueSelected(this.defaultPeriodSelection.value), 
                this.filterItemsService.getMaxValueSelected(this.defaultPeriodSelection.value), 
                this.filterItemsService.getCountryIds(), 
                providerIds, publisherIds, this.defaultPeriodSelection.label);
            this.filterChanged.emit(this.filters);
        }
    }

    public onPeriodValueChanged(item: DropdownValue) {
        this.filters.period = item.label;
        if (item.value !== this.customValue) {
            this.filters.startDate = this.filterItemsService.getMinValueSelected(item.value);
            this.filters.endDate = this.filterItemsService.getMaxValueSelected(item.value);
        }
        else
            this.resetDatePickers();
        this.showCustomPeriod = item.value === this.customValue;
    }

    public onCountryValueChanged(item: DropdownValue) {
        if (item.value === 0)
            this.filters.countryIds = this.filterItemsService.getCountryIds();
        else {
            this.filters.countryIds = new Array<number>();
            this.filters.countryIds.push(item.value);
        }
    }

    public onProviderValueChanged(providerIds: number[]) {
        if (this.showProviders) {
            this.filters.providerIds = providerIds;
        }
    }

    public onFilter(event) {
        let filters = this.filters;
        if (this.showCustomPeriod) {
            if (!this.startDate || !this.endDate) {
                this.dateError = 'Please select from and to date!';
                return;
            }
            if (this.startDate > this.endDate) {
                this.dateError = consts.StartDateGreaterThanEndDateText;
                return;
            }
            this.dateError = null;
            filters.startDate = this.startDate;
            filters.endDate = this.endDate;
        }
        this.filterChanged.emit(filters);
    }

    public onDateClicked(event) {
        let ng2datePicker = this.el.nativeElement.querySelectorAll("ng2-datetime-picker[draggable='true']");
        $(ng2datePicker).attr('draggable','false');
    }

    public onMinDateChanged(newDate) {
        if (this.endDate && this.startDate) {
            let datePickers = this.el.nativeElement.querySelectorAll("[data-datepicker]");
            if (datePickers && datePickers[1]) {
                datePickers[1].value = '';
                this.endDate = null;
            }
        }
    }

    public onResetFilters(event) {
        this.defaultPeriodSelection = this.filterItemsService.getDefaultPeriodSelection();
        this.defaultCountrySelection = this.filterItemsService.getDefaultCountrySelection(true);
        let providerIds = new Array<number>();
        // if (this.showProviders) {
            providerIds = this.filterItemsService.getNonConfigurableProvidersIds();
        // }
        this.providerTreeSelectionModalComponent.resetSelection();
        this.filters = new DashboardFilterModel(
            this.filterItemsService.getMinValueSelected(this.defaultPeriodSelection.value), 
            this.filterItemsService.getMaxValueSelected(this.defaultPeriodSelection.value), 
            this.filterItemsService.getCountryIds(), 
            providerIds, this.filterItemsService.getPublishersIds(), this.defaultPeriodSelection.label);
        this.resetDatePickers();
        this.filterChanged.emit(this.filters);
    }

    public onPublishersChanged(publisherIds) {
        let filters = this.filters;
        filters.publisherIds = publisherIds;
        this.filterChanged.emit(filters);
    }

    private resetDatePickers() {
        this.showCustomPeriod = false;
        let datePickers = this.el.nativeElement.querySelectorAll("[data-datepicker]");
        if(this.browserSerive.isIE())
            datePickers = [datePickers];
        if (datePickers) {
            //forEach not supported in IE
            datePickers.forEach(element => {
                element.value = '';
            });
        }
    }

  
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-filter.component.ts